module.exports = __webpack_public_path__ + "static/media/video-image-1.bbe9f775.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/images/video-image-1.png
// module id = 116
// module chunks = 0